
import Vue from "vue";
export default Vue.extend({
	props: {
		up: Boolean,
		roundedTop: Boolean,
		roundedBottom: Boolean,
		maxHeight: {
			type: Number,
			default: 400
		}
	}
});
